<ng-container *transloco="let t">
    @let required = required$ | async;
    @let valueChanges = valueChanges$ | async;
    @let statusChanges = statusChanges$ | async;
    @let isExpanded = isExpanded$.$ | async;

    @if (!isExpanded && !forceExpanded) {
        <bazis-button
            [fill]="fillShortButton()"
            class="tms-button_search"
            (click)="expandedField()"
        >
            <bazis-icon
                slot="icon-only"
                name="search"
            ></bazis-icon>
        </bazis-button>
    }
    <div
        [hidden]="!isExpanded && !forceExpanded"
        [class]="'bazis-control ' + cssClassSizeControl"
        [ngClass]="{
            'bazis-control--focused': isFocused,
            'bazis-control--dirty': ngControl.control.dirty,
            'bazis-control--empty': emptyValues.indexOf(ngControl.control.value) > -1,
            'bazis-control--invalid': ngControl.control.invalid,
            'bazis-control--disabled': field.disabled,
        }"
    >
        <div
            class="bazis-control__field-group"
            [class.bazis-control__field-group--disabled]="field.disabled"
            [class.bazis-control__field-group--focused]="isFocused"
        >
            <bazis-control-field-start
                [isClickable]="isLeftIconClickable"
                [icon]="'search'"
                [tooltipText]="t(tooltipKey, tooltipParams)"
                [tooltipSettings]="tooltipSettings"
                (actionClick)="onLeftIconClick($event)"
            >
            </bazis-control-field-start>

            <div
                class="bazis-control__field-wrapper"
                #fieldWrapRef
            >
                <input
                    #searchInput
                    [type]="type"
                    class="bazis-control__field"
                    [ngClass]="{
                        'bh-no-padding': withoutInnerPadding,
                        'bazis-control__field--erasable': hasEraser,
                    }"
                    [placeholder]="
                        placeholder ? placeholder : placeholderKey ? t(placeholderKey) : ''
                    "
                    (focus)="focusField($event)"
                    (blur)="blurField($event)"
                    [formControl]="field"
                    [maxlength]="maxLength"
                />
            </div>

            @if (!forceExpanded) {
                <bazis-control-field-end
                    #fieldEnd
                    [isClickable]="true"
                    [icon]="'cross'"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipSettings]="tooltipSettings"
                    [canEraserShow]="false"
                    [value]="ngControl.control.value"
                    (actionClick)="clearAndClose()"
                >
                </bazis-control-field-end>
            } @else {
                <bazis-control-field-end
                    #fieldEnd
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipSettings]="tooltipSettings"
                    [canEraserShow]="true"
                    [value]="ngControl.control.value"
                    (erased)="onClear($event)"
                >
                </bazis-control-field-end>
            }
        </div>

        <!-- <bazis-infinite-list
                [searchSettings]="searchSettings"
                [emptyValue]="emptyValueEntity"
                [excludeIds$]="excludeIds$"
                emptyListKey="title.emptySearch"
                [search$]="ngControl.control.valueChanges"
            >
                <ng-template let-item="item">
                    <div
                        class="bazis-item"
                        [class.bazis-item--selected]="
                            valuesMap &&
                            valuesMap.has(
                                searchSettings.fieldForId
                                    ? item.$snapshot[searchSettings.fieldForId]?.id
                                    : item.id
                            )
                        "
                        (click)="
                            toggleValue(
                                searchSettings.fieldForId
                                    ? item.$snapshot[searchSettings.fieldForId]?.id
                                    : item.id
                            )
                        "
                    >
                        <ng-container
                            *ngIf="infiniteListTpl"
                            [ngTemplateOutlet]="infiniteListTpl"
                            [ngTemplateOutletContext]="{ item: item }"
                        ></ng-container>
                        <ng-container *ngIf="!infiniteListTpl">
                            {{
                                item.$snapshot.name ||
                                    item.$snapshot[nameField] ||
                                    t(item.$snapshot.nameKey)
                            }}
                        </ng-container>
                    </div>
                </ng-template>
            </bazis-infinite-list> -->

        <div class="bazis-control__error">
            <bazis-form-error
                [validationErrorMessages]="validationErrorMessages"
                [formControl]="field"
            ></bazis-form-error>
            @if (field.status === 'VALID') {
                <bazis-form-error
                    [validationErrorMessages]="validationErrorMessages"
                    [formControl]="ngControl.control"
                ></bazis-form-error>
            }

            <!-- для ошибок родительского контрола
            (пример использоавния в input-text-array, предполагается сюда "вложить" bazis-form-error) -->
            <ng-content></ng-content>
        </div>

        @if (noteKey) {
            <div class="bazis-control__note">
                {{ t(noteKey, noteParams) }}
            </div>
        }
        <ng-content select="note"></ng-content>
    </div>
</ng-container>
